// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__10jRM","errorLogs":"EditorFooter_errorLogs__3aIe1"};